import { useAuthStore } from "@src/stores/auth-store";
import { getSocket } from "@src/utils/websocket";
import { useEffect } from "react";
import {useQueryClient} from 'react-query';
import {votingKeys} from '@src/queries/voting.queires';

interface NewNotificationEvent {
    newNotification?: boolean;
    newVote?: boolean;
    voteDashboardRefresh?: {voteId: string};
}

export function useShowNotificationPopupOnNewVote(setModal: (it: boolean) => void, setVoteId: (id: string) => void) {
    const token = useAuthStore().token;
    const queryClient = useQueryClient();

    useEffect(() => {
        const socket = getSocket(token);
        if (!socket) {
            return;
        }
        function onNewNotification(notification: NewNotificationEvent) {
            // Every new notification (news, votes, ...) lands in the bell list.
            queryClient.invalidateQueries({queryKey: ['notifications']});
            queryClient.invalidateQueries({queryKey: ['notifications-not-infinite']});
            if (notification.newVote === true && notification.voteDashboardRefresh) {
                const voteId = notification.voteDashboardRefresh.voteId;
                queryClient.invalidateQueries({queryKey: ['votingList']});
                queryClient.invalidateQueries({
                    queryKey: votingKeys.votingListDetails(voteId),
                });
                setModal(true);
                setVoteId(voteId);
                return;
            }
            // News notification - refresh news lists and unread counters.
            queryClient.invalidateQueries({queryKey: ['news']});
            queryClient.invalidateQueries({queryKey: ['myClubs']});
            queryClient.invalidateQueries({queryKey: ['myClub']});
        }
        socket.on("newNotification", onNewNotification);

        return () => {
            socket.off("newNotification", onNewNotification);
        };
  }, [queryClient, setModal, setVoteId, token]);
}
